import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { isNumeric } from '../../objects/CommonUse/checkIfNumeric';
import initializeErrorArray from './objects/initialize_error_array';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import TableRowCard from '../shared-components/table_row_card';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';

class ChangeAccountModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                headers: setHeadersForFetch(),
                accountNbrFound: false,
                accountLoaded: false,
                subProcess: "ChangeAccountModal",
                environment: Config.dataURL.currentEnv,
              }
              this.errArray = initializeErrorArray(5);
              this.dataValidSw = true;
              this.prevAccountNbr = "";
     }
  
  buildRowColumnArrs(){
        let rqstdUsersArr = this.accountInfo.rqstdUsersArr;
        this.rqstdUsersArr = [];
        for (let i=0; i< rqstdUsersArr.length; i++){              let reformatDateRqstd = reformatDateToDisplay(rqstdUsersArr[i].dateRqstd, "YYYY/MM/DD");
              let rqstdUserObj = {index: reformatDateRqstd, column1: rqstdUsersArr[i].role, 
                column2: rqstdUsersArr[i].nbrUsersRqstd};
              this.rqstdUsersArr.push(rqstdUserObj);
        }
  }
 
  editInput(){
    this.dataValidSw = true;
    this.errArray = initializeErrorArray(5);
    this.getFormValues();
    if (this.dataValidSw === true && this.newAccountNbr === false){
        this.formatRqstdUsersArr();
        this.accountObj={accountNbr: this.accountNbr, ownerName: this.ownerName,
          rqstdUsersArr: this.rqstdUsersArr};
        this.updateAccount();
        let accountObj = {accountNbr: this.accountNbr, ownerName: this.ownerName,
          primaryRole: this.primaryRole, nbrPrimary: this.nbrPrimary, nbrPlayers: this.nbrPlayers }
        this.props.onClose(accountObj);
    }
  }

  getFormValues(){
      this.accountNbr = document.getElementById("accountNbr").value;
      if (this.prevAccountNbr !== this.accountNbr){
          this.getAccountInfo();
          this.prevAccountNbr = this.accountNbr;
          this.newAccountNbr = true;
      }else{
          this.newAccountNbr = false;
          this.ownerName = document.getElementById("ownerName").value;
          this.primaryRole = document.getElementById("primaryRole").value;
          this.nbrPrimary = document.getElementById("nbrPrimary").value;
          this.nbrPlayers = document.getElementById("nbrPlayers").value;
          this.editFormValues();
      }
           
  }

  getAccountInfo(){
        this.accountInfo = this.props.accountList.find(elem => elem.accountNbr === this.accountNbr);
        if (!this.accountInfo){
            this.errorMsg = "Account number does not exist.";
            this.checkErrorArray(0);
        }else{
            this.buildRowColumnArrs();
            this.setState({accountNbrFound: true});
        }
  }
  
  editFormValues(){
    //  let emailAddressValid = validator.isEmail(this.emailAddress);
    if (this.ownerName === ""){
        this.ownerName = this.accountInfo.ownerName;
    }
    if (this.ownerName === ""){
          this.errorMsg = "Owner Name is required - s/b a valid user name!!";
          this.checkErrorArray(1);
    }
    if (this.primaryRole === "none" && this.nbrPrimary !== ""){
          this.errorMsg = "Primary Role is required";
          this.checkErrorArray(2);
    }
    if (this.nbrPrimary !== ""){
        const validNbrPrimary = isNumeric(this.nbrPrimary);
        if (validNbrPrimary === false){
            this.errorMsg = "Primary Number must be numeric";
            this.checkErrorArray(3);
        }
    }
    if (this.nbrPlayers !== ""){
        const validNbrPlayers = isNumeric(this.nbrPlayers);
        if (validNbrPlayers === false){
            this.errorMsg = "Player Number must be numeric";
            this.checkErrorArray(4);
        }
    }
  } 
     
 checkErrorArray(msgIndex){
    if (this.errorMsg  && this.errorMsg !== ""){
        this.errArray[msgIndex] = {textType: "text-danger", 
            message: this.errorMsg};
        this.dataValidSw = false;
    }
  }

  formatRqstdUsersArr(){
      const dateObj =  getCurrentDateTime(); 
      this.rqstdUsersArr = this.accountInfo.rqstdUsersArr;
      if (this.nbrPrimary !== ""){
          let rqstUserObj = {role: this.primaryRole, dateRqstd: dateObj.date, nbrUsersRqstd: this.nbrPrimary};
          this.rqstdUsersArr.push(rqstUserObj);
      }
      if (this.nbrPlayers !== ""){
          let rqstUserObj = {role: "player", dateRqstd: dateObj.date, nbrUsersRqstd: this.nbrPlayers};
          this.rqstdUsersArr.push(rqstUserObj);
      }
     
  }

     
    render() {
        if (this.state.accountNbrFound === true){
            this.rqstdUserList = this.rqstdUsersArr.map((tableRows,index) =>
                <TableRowCard tableInfo={tableRows} key={index}/> );
        };
        
    return <>
         <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
            size="lg"  scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title>Account Change Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
            <form className="text-left">
                <p>Please complete all fields on this form and then click 
                   'Submit'.</p>
                <div>
                   <label className="font-weight-bold" htmlFor="accountNbr">
                        Account Number:&nbsp;&nbsp;</label>
                  <span className={this.errArray[0].textType}>
                          &nbsp;{this.errArray[0].message}</span>
                   <input type="text" className="col-med" id="accountNbr" name="accountNbr"></input> 
                </div>
                {this.state.accountNbrFound  ?
                <span>
                    <div className="mt-2">
                        <h4 className="text-center table-header-background">Current Account Information</h4>
                            <div className="row">
                            <div className="col-md font-weight-bold">Owner Name:</div>
                            <div className="col-md">{this.accountInfo.ownerName}</div>
                        </div>
                        <h6 className="mt-4 text-center font-weight-bold">Related Players List</h6>
                         <table className="mt-2 mx-4 ">
                            <tbody className="mt-4">
                              <tr className="text-center row-100">
                                 <th className="col-md-2 p-0">Date Rqstd</th>
                                 <th className="col-md-4 text-left p-0">Player Name</th>
                                 <th className="col-md-6 text-center p-0">Game Status</th>
                              </tr>
                                {this.rqstdUserList}
                            </tbody>
                          </table>
                                                                   
                    </div>
                    <h4 className="text-center table-header-background mt-4">New Account Information</h4>
                    <div >
                        <label className="mt-2 font-weight-bold" htmlFor="ownerName">
                            Owner Name:&nbsp;&nbsp;</label>
                        <span className={this.errArray[1].textType}>
                            &nbsp;{this.errArray[1].message}</span>
                        <input type="text" className="col-lg" id="ownerName" name="ownerName"></input> 
                    </div>
                    <div className="mt-2">
                      <label className="font-weight-bold" htmlFor="primaryRole">Primary Role:&nbsp;&nbsp;</label>
                        <select 
                            className="btn btn-sm btn-outline-secondary dropdown-toggle" id="primaryRole">
                              <option value="none">primary role not selected</option>
                              <option value="parent">Parent</option>
                              <option value="teacher">Teacher</option> 
                        </select>
                        <span className={this.errArray[2].textType}>
                              &nbsp;{this.errArray[2].message}</span>
                    </div>
               
                    <div className="mt-2">
                        <label className="font-weight-bold" htmlFor="nbrPrimary">
                            Number of Primary Ids:&nbsp;&nbsp;</label>
                        <input type="text" className="col-small" id="nbrPrimary" name="nbrPrimary"></input> 
                        <span className={this.errArray[3].textType}>
                          &nbsp;{this.errArray[3].message}</span>
                    </div> 
                               
                    <div className="mt-2">
                        <label className="font-weight-bold" htmlFor="nbrPlayers">
                            Number of Player Ids:&nbsp;&nbsp;</label>
                        <input type="text" className="col-small" id="nbrPlayers" name="nbrPlayers"></input> 
                       <span className={this.errArray[4].textType}>
                          &nbsp;{this.errArray[4].message}</span>
                    </div> 
                </span>
                :
                    null
                }
               
            </form>
           </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
          {this.dataValidSw ?
            <div></div>
          :
            <div className="text-danger">Please Correct errors and try-again.</div>
          }
          <Button variant="secondary"   onClick={() => this.props.onClose()}>
              Close
          </Button>
          <Button variant="primary"  onClick={() => this.editInput()}>
              Submit
          </Button>
        </Modal.Footer>
        </Modal>
        </>
    }

updateAccount(){
    const currDateTime = getCurrentDateTime(); 
    // Update phase in events collection
    const bodyObj = {
        "accountNbr": this.accountObj.accountNbr,
        "ownerName": this.accountObj.ownerName,
        "rqstdUsersArr": this.accountObj.rqstdUsersArr,
        "dateUpdated": currDateTime.date};
    const funcName = "updateAccount";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
         {method:'PUT', headers: this.state.headers,
          body: JSON.stringify(bodyObj)})
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        alert("Update successful! Confirm events " +
                        "collection has been updated as expected.")
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: bodyObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

}

export default ChangeAccountModal;